import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type DeleteCustomMaterials = ClientInferResponseBody<
  typeof contract.materials.deleteCustomMaterials
>;

export const deleteCustomMaterials = async (): Promise<DeleteCustomMaterials> => {
  const response = await api.materials.deleteCustomMaterials.mutation({
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to delete CustomMaterials", response.status, response.body);
};
